export default "/dist/files/icone_localisation.ccad7849550dfb9d1f540dc6e9f0424f.svg";